// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/pc/assets/css/style.css
// module id = 696
// module chunks = 14